import React, { useState, useEffect, useMemo, useRef }  from "react";
import {Line, defaults} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import ContentBox from "./ContentBox";
import { ClientSelectSuministroElectrico } from "./ClientSelectSuministroElectrico";
import { useMediaQuery } from 'react-responsive';
import { getConsumptionSuministroElectrico, getCodesConsumptionSuministroElectrico } from "../api";
import calendar from "../img/calendar.svg";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import moment from "moment";
import PostFileDownloadElectricCSV from './PostFileDownloadElectricCSV';
import Button2 from './Button2';

export function ServiciosSuministroElectricoHistorialConsumos({
  loading,
  selectedService,
  services,
  setSelectedService,
}) {

  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);
  const [pages, setPages] = useState([]);
  const [instalations, setInstalations] = useState([]);
  const [instalation, setInstalation] = useState({});
  const [instalationIndex, setInstalationIndex] = useState('disabled');
  
  // Ref para controlar la cancelación de búsquedas anteriores
  const currentSearchRef = useRef({ id: 0, cancelled: false });
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return date;
  });
  const [endDate, setEndDate] = useState(new Date());
  const [horario, setHorario]= useState('');
  const [granularity, setGranularity]= useState('');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const pageSize = 1000;
  const formattedDates = useMemo(
    () => ({
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
    }),
    [startDate, endDate]
  );


  const fetchDataForSelectedService = useMemo(() => {
    return () => {
      if (!selectedService?.abastible_contract_id) {
        setError("Debe seleccionar un suministro eléctrico");
        return;
      }

      //setLoading(true);
      setError(null);
      setMessage(null);
      setLabels([]);
      setValues([]);
      setPages(0);

      try {
        getCodesConsumptionSuministroElectrico(
          parseInt(selectedService.abastible_contract_id),
          (error, response) => {

            if (error) {
              setError(
                error.message || "Error al obtener consumos"
              );
              return;
            }

            if (response?.data) {
              if(Array.isArray(response?.data)){
                setInstalations(response.data)
                if(response.data.length == 1){
                  setInstalationIndex(0);
                  setInstalation(response.data[0]);
                } else {
                  setInstalation({});
                  setInstalationIndex('disabled');

                }
                setError(null);
                setMessage(null);
                return;
              }
            }

            if (response?.message) {
              setMessage(response.message);
              setError(null);
              return;
            }

            setError("Error al obtener consumos");
          }
        );

      } catch (err) {
        console.error("Error:", err);
        setError("Error al obtener consumos");
        //setLoading(false);
        setLabels([]);
        setValues([]);
      }
    };
  }, [selectedService?.abastible_contract_id]);

  const fetchConsumptionSuministroElectrico = async () => {
    // Limpiar el gráfico y mensajes inmediatamente
    setError(null);
    setMessage(null);
    setLabels([]);
    setValues([]);
    setPages(0);
    
    // Cancelar la búsqueda anterior
    currentSearchRef.current.cancelled = true;
    
    // Crear un nuevo ID de búsqueda
    const searchId = currentSearchRef.current.id + 1;
    currentSearchRef.current = { id: searchId, cancelled: false };
    
    // Guardar referencia local a esta búsqueda
    const thisSearch = currentSearchRef.current;

    try {
      const first = await getConsumptionPage(0);

      // Verificar si esta búsqueda fue cancelada
      if (thisSearch.cancelled) {
        console.log(`Búsqueda ${searchId} cancelada antes de procesar primera página`);
        return;
      }

      if (first.status === 'empty') {
        setMessage('Sin resultados');
        return;
      }

      let allLabels = [...first.labels];
      let allValues = [...first.values];

      // Mostrar la primera página inmediatamente
      if (!thisSearch.cancelled) {
        setLabels(allLabels);
        setValues(allValues);
      }

      let currentPage = first.page.number;
      const totalPages = first.page.totalPages;

      // Loop para páginas siguientes
      while (currentPage + 1 < totalPages) {
        // Verificar si fue cancelada antes de solicitar la siguiente página
        if (thisSearch.cancelled) {
          console.log(`Búsqueda ${searchId} cancelada en página ${currentPage + 1} de ${totalPages}`);
          return;
        }
        
        currentPage++;

        const next = await getConsumptionPage(currentPage);

        // Verificar nuevamente después de recibir la respuesta
        if (thisSearch.cancelled) {
          console.log(`Búsqueda ${searchId} cancelada después de cargar página ${currentPage}`);
          return;
        }

        allLabels = allLabels.concat(next.labels);
        allValues = allValues.concat(next.values);
        
        // Actualizar el gráfico progresivamente con cada página cargada
        setLabels(allLabels);
        setValues(allValues);
      }

      // Actualizar el total de páginas al finalizar (solo si no fue cancelada)
      if (!thisSearch.cancelled) {
        setPages(totalPages);
      }

    } catch (err) {
      // Solo actualizar el estado de error si esta búsqueda sigue siendo válida
      if (!thisSearch.cancelled) {
        setLabels([]);
        setValues([]);
        setPages(0);
        setError(err.message || "Error al obtener consumos");
      }
    }
  };


  const getConsumptionPage = (page) => {
    return new Promise((resolve, reject) => {
      getConsumptionSuministroElectrico(
        selectedService.abastible_contract_id,
        parseInt(instalation.codigoSapInstalacion),
        formattedDates.start_date,
        formattedDates.end_date,
        granularity,
        horario,
        pageSize,
        page,
        (error, response) => {
          if (error) reject(error);
          else resolve(response);
        }
      );
    });
  };





  useEffect(() => {
    if (selectedService) {
      fetchDataForSelectedService();
    }
  }, [selectedService]);

  useEffect(() => {
    if (instalationIndex && instalationIndex != 'disabled') {
      setInstalation(instalations[instalationIndex]);
    }
  }, [instalationIndex]);
 // Filtrar datos por rango de fechas seleccionado
  const { filteredLabels, filteredValues } = useMemo(() => {
    if (!values || values.length === 0) {
      return { filteredLabels: [], filteredValues: [] };
    }

    const startMoment = moment(startDate).startOf('day');
    const endMoment = moment(endDate).endOf('day');

    const filtered = [];
    const filteredLabs = [];

    for (let i = 0; i < values.length; i++) {
      const item = values[i];
      if (!item.fecha_hora) continue;

      const itemDate = moment(item.fecha_hora);
      
      // Solo incluir si está dentro del rango seleccionado
      if (itemDate.isSameOrAfter(startMoment) && itemDate.isSameOrBefore(endMoment)) {
        filtered.push(item);
        filteredLabs.push(labels[i]);
      }
    }

    return { filteredLabels: filteredLabs, filteredValues: filtered };
  }, [values, labels, startDate, endDate]);


  let graphHeight = 25;
  graphHeight = useMediaQuery({query: '(max-width: 1100px)'})?40:graphHeight;
  graphHeight = useMediaQuery({query: '(max-width: 800px)'})?60:graphHeight;  
  graphHeight = useMediaQuery({query: '(max-width: 300px)'})?80:graphHeight;
  let graphData = {
    labels: filteredLabels, 
    datasets: [{
      label: 'Consumo',
      fill: false,
      borderWidth: 3,
      borderColor: 'rgba(75, 192, 192, 1)', 
      fill: false,
      pointRadius: 2,
      pointHoverRadius: 4,
      data:filteredValues.map(v => v.consumo_kwh),
      extraData: filteredValues
    }]
  };

  const { diffInDays, diffInMonths, diffInYears } = useMemo(() => {
    if (!startDate || !endDate) {
      return {
        diffInDays: 0,
        diffInMonths: 0,
        diffInYears: 0
      };
    }

    const diffInMs = endDate.getTime() - startDate.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    const diffInMonths = diffInDays / 30;   // fijo: 30 días por mes
    const diffInYears = diffInDays / 365;   // fijo: 365 días por año

    return { diffInDays, diffInMonths, diffInYears };
  }, [startDate, endDate]);

  return (
    <ContentBox loading={loading ?? false}>
      <div className="title-client-container clearfix">
        <h1>Historial de Consumos</h1>
        <div className="client-number">
          <ClientSelectSuministroElectrico
            selected={selectedService}
            services={services}
            setSelected={setSelectedService}
            number_field={"abastible_contract_id"}
          />
        </div>
      </div>
      <div className="col-100 left d-flex justify-between margin-bottom-40">
        <div className="filter-container grid-column-3">
          <div className="position-relative">
              <select value={instalationIndex} onChange={(e) => {setInstalationIndex(e.target.value)}}>
                    <option key={'disabled'} value={'disabled'} disabled>Seleccione Instalación</option>
                  {instalations.map((inst, mindx) => (
                    <option key={mindx} value={mindx}>{inst.razonSocialCliente} - {parseInt(inst.codigoSapInstalacion)}</option>
                  ))}
              </select>
          </div>
          <div className="position-relative">
            <img className="calendar" src={calendar} alt="calendario" />
            <DatePicker
              popperModifiers={{ flip: { enabled: false } }}
              maxDate={endDate}
              dateFormat="dd/MM/yyyy"
              placeholderText="Desde"
              selected={startDate}
              locale="es"
              onChange={(date) => {
                setStartDate(date);
                setError(null);
                setMessage(null);
              }}
            />
          </div>
          <div className="position-relative">
            <img className="calendar" src={calendar} alt="calendario" />
            <DatePicker
              popperModifiers={{ flip: { enabled: false } }}
              minDate={startDate}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="Hasta"
              selected={endDate}
              locale="es"
              onChange={(date) => {
                setEndDate(date);
                setError(null);
                setMessage(null);
              }}
            />
          </div>
          <div className="position-relative">
              <select value={granularity} onChange={(e) => {setGranularity(e.target.value)}}>
                  <option value="">Cada 15 Minutos</option>
                  <option value="hourly">Por hora</option>
                  <option value="daily">Diaria</option>
                  {diffInMonths >= 1 && <option value="monthly">Mensual</option>}
                  {diffInYears >= 1 && <option value="yearly">Anual</option>}
              </select>
          </div>
          <div className="position-relative">
              <select value={horario} onChange={(e) => {setHorario(e.target.value)}}>
                  <option value="">Dia y Noche</option>
                  <option value="D">Dia</option>
                  <option value="N">Noche</option>
              </select>
          </div>
          <button
            className="button orange"
            onClick={fetchConsumptionSuministroElectrico}
            disabled={loading}
          >
            {loading ? "Cargando..." : "Filtrar"}
          </button>
          <PostFileDownloadElectricCSV
              labels={labels}
              values={values}
              contentRender={() =>
                <div className="linkA-container">
                  <Button2 label={"Descargar CSV"} className="button button-border-orange" />
                </div>
              }
          />
        </div>
      </div>
      {(instalation?.razonSocialCliente && values?.length)?<div className="col-100 left d-flex margin-top-40 margin-bottom-20">
        <div className="col-60">
          <h2 className="asociar-servicios-sugerencias" style={{fontSize: "x-large"}}>Consumo eléctrico (kWh) – Cliente: {instalation.razonSocialCliente}</h2>
        </div>
      </div>:null}
      {message?
        (<div className="col-100 d-flex margin-bottom-20">
          <p className="margin-top-30" style={{fontSize: "x-large"}}>{message}</p>
        </div>
        ):null
      }
      {values?.length?
      <Line
        data={graphData}
        width={100}
        height={graphHeight}
        options={{
          plugins: {
            datalabels: {
              clamp: true,
              anchor: "end",
              align: "top",
              offset: -4,
              display: false,
              color: 'black',

            }

          },
          maintainAspectRatio: true,
          legend: {
            display: false
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: function (tooltipItem, data) {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const index = tooltipItem.index;
                const extra = dataset.extraData?.[index];

                const consumo = tooltipItem.yLabel;
                const horario = extra?.horario === 'N' ? 'Noche' : 'Día';

                if(['daily', 'monthly', 'yearly'].includes(granularity)){
                  return [
                    `Consumo: ${consumo.toLocaleString("de")} kWh`,
                  ];
                }else{
                  return [
                    `Consumo: ${consumo.toLocaleString("de")} kWh`,
                    `Horario: ${horario}`,
                  ];
                }
              },
              title: function (tooltipItems, data) {
                const label = tooltipItems[0].label;
                return `${label}`;
              }
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                /*callback: function(value, index, values) {
                  return value;
                }*/
              },
              barPercentage: 0.5,
              gridLines: {
                color: "rgba(0,0,0,0)"
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }],
            yAxes: [{
              ticks: {
                maxTicksLimit: 5
              },
              scaleLabel: {
                display: true,
                labelString: 'kWh'
              }
            }]
          }
        }}
      />:null}

    </ContentBox>
  );
}
